<form [formGroup]="form">
  @if (equipmentLoading) {
    <span class="text-body-secondary font-italic">
      {{ 'Loading Equipment...' | messageTranslate }}
    </span>
  } @else {
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-12 form-group">
            <label for="to" class="text-body-secondary form-label">{{ 'To' | messageTranslate }}:</label>
            <input id="to" name="to" type="text" class="form-control" [formControlName]="ControlNames.to" (blur)="onTouched()">
            <app-errors [control]="form.controls[ControlNames.to]"/>
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-group">
            <label for="cc" class="text-body-secondary form-label">{{ 'Cc' | messageTranslate }}:</label>
            <input id="cc" name="cc" type="text" class="form-control" [formControlName]="ControlNames.cc" (blur)="onTouched()">
            <app-errors [control]="form.controls[ControlNames.cc]"/>
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-group">
            <label for="subject" class="text-body-secondary form-label">{{ 'Subject' | messageTranslate }}:</label>
            <input id="subject" name="subject" type="text" class="form-control" [formControlName]="ControlNames.subject" (blur)="onTouched()">
            <app-errors [control]="form.controls[ControlNames.subject]"/>
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-group">
            <label for="body" class="text-body-secondary form-label">{{ 'Body' | messageTranslate }}:</label>
            <textarea id="body" name="body" rows="6" class="form-control" [formControlName]="ControlNames.body" (blur)="onTouched()"></textarea>
            <app-errors [control]="form.controls[ControlNames.body]"/>
          </div>
        </div>
      </div>
    </div>
  }
</form>
